import { FindTriggerAbility } from '@/axios/IDevice.js'
import { warning } from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket';

const triggerMixins = {
  data() {
    return {
      timeOption: [], // 定时集合
      sunOption: null, // 日出日落数据
      optionsAdd4: [
        {
          value: 0,
          label: this.$t('iftttset.allcondition')
        },
        {
          value: 1,
          label: this.$t('iftttset.onecondition')
        }
      ],
      triggerTypeList: [
        {
          value: 'a',
          label: this.$t('iftttset.timing'),
          disabled: false
        },
        {
          value: 'd',
          label: this.$t('ifttt.sunriseSunset'),
          disabled: false
        },
        {
          value: 'b',
          label: this.$t('iftttset.device'),
          disabled: false
        },
        {
          value: 'c',
          label: this.$t('iftttset.handledo'),
          disabled: false
        }
      ],
      triggermanual: [], // trigger手动执行对象
      multipleCur:[],  // 多选能力
      timingset: false, // 定时弹窗激活
      triggle: false,
      dialogGroup: false, // 设备组弹窗激活trigger选择
      triggleaction: [], // triggle的触发设置集合
      temtriggle: null, // 一个设备的单个triggle(点击单选选中)
      multipleTemtriggle: [], // 一个设备的多选能力
      deviceOption: [], // 选中的triggle设备
      titlevalue: this.$t('iftttset.select'), // 满足所有条件 满足所有条件
      fileSizeShow: true,
      multipleDialogGroup: false, // 区分设备选择是否过滤已经选中设备
      canMultipleSelect: true, //是否可以多选
    }
  },

  methods: {
    delDevice (item, index) {
      // 删除trigger设备
      this.deviceOption.splice(index, 1)
      this.delsuccess()
      this.formatelistTrigger()
      this.drowisdisabled()
    },
    
    triggleTimeAdd () {
      if (!this.value1) {
        warning(this, this.$t('iftttset.SelecTime'))
      } else {
        let isadd = true
        this.timeOption.forEach(n => {
          if (n === this.value1) {
            isadd = false
            warning(this, this.$t('iftttset.haveTime'))
          }
        })
        if (this.modifyItem != null) {
          this.timeOption[0] = this.value1
        } else if (isadd) {
            this.timeOption.push(this.value1)
          }
        this.timingset = false
        this.setDisabled('g')
      }
    },
    // 删除定时
    delTime (index) {
      this.timeOption.splice(index, 1)
      this.delsuccess()
      this.drowisdisabled()
    },
    // 删除日出日落
    delSun () {
      this.sunOption = null
      this.delsuccess()
      this.drowisdisabled()
    },
    checkRadio (item, index) {
      if(index<0) return
      this.cur = index
      //支持单设备多选能力
      if(this.canMultipleSelect){
        if(this.multipleCur.indexOf(index) === -1){
        this.multipleCur.push(index)
        this.multipleTemtriggle.push(item)
      }else{
        this.multipleCur.splice(this.multipleCur.indexOf(index),1)
        this.multipleTemtriggle.splice(this.multipleTemtriggle.indexOf(item),1)
      }
      }else{
        this.multipleCur= [index]
        this.multipleTemtriggle = [item]
      }
      item.ischeck = !item.ischeck
      this.temtriggle = item
    },

    delmanualTrigger (item, index) {
      if (this.iftttmodel) {
        if (!this.iftttmodel.IsManual) {
          this.triggermanual.splice(index, 1)
          this.delsuccess()
          this.drowisdisabled()
        } else {
          warning(this, this.$t('iftttset.handlewarning'))
        }
      } else {
        this.triggermanual.splice(index, 1)
        this.delsuccess()
        this.drowisdisabled()
      }
    },

    /**
     * 自动化 - 条件对象添加按钮是否显示
     */
    triggerObjAdddataShow () {
      if (
        this.timeOption.length + this.deviceOption.length >= this.$store.state.deployParamter.ifttt.triggershowtotal
      ) {
        return false;
      }

      return true;
    },

    modifyTriggerTime(item) {
      this.modifyItem = item;

      this.value1 = item;
      this.value2 = '';
      this.value3 = '';
      this.timingset = true;

    },

    // 去掉增加设备的现有能力,进行覆盖更新
    alreadTrigle() {
      const deviceIds = new Set(this.addDevicesTemp.map(item => item.VDeviceId));

      this.deviceOption = this.deviceOption.filter(item => !deviceIds.has(item.VDeviceId));
    },

    // 给trigger排序
    formatelistTrigger() {
      this.deviceOption = this.deviceOption.map((item, index) => ({...item, locationindex: index}))
    },

    eidtorTriggerformate () {
      // trigger编辑初始化数据
      this.iftttmodel.TriggerList.forEach((n, index) => {
        if (n.VDeviceId) {
          n.locationindex = index
          this.editorDoFindTriggerAbility(n)
        } else {
          if (n.time) {
            // 初始化定时
            this.timeOption.push(n.time)
          }
          if (n.TriggerType === 2) {
            this.triggermanual.push({ TriggerType: 2, TRI_NAME: '' })
          }
          if (n.TriggerType === 3) {
            // 初始化日出日落
            const timeMode = n.TimeMode != null ? n.TimeMode : n.Mode
            const modeLabel = timeMode === 1 ? this.$t('iftttset.sunrise') : this.$t('iftttset.sunset')
            let label = ''
            if (n.Offset === 0) {
              label = `${modeLabel} ${this.$t('iftttset.hour')}`
            } else if (n.Offset > 0) {
              label = `${modeLabel}${this.$t('base.after')}${n.Offset}${this.$t('tianmu.minutes')}`
            } else {
              label = `${modeLabel}${this.$t('base.before')}${Math.abs(n.Offset)}${this.$t('tianmu.minutes') }`
            }
            this.sunOption = {
              TriggerType: 3,
              Mode: timeMode,
              Offset: n.Offset,
              Longitude: n.Longitude,
              Latitude: n.Latitude,
              Label: label
            }
          }
        }
      });
    },

    async editorDoFindTriggerAbility(item) {
      const rs = await FindTriggerAbility({ vDeviceId: item.VDeviceId });

      if (rs?.StatusCode !== this.$store.state.rightStatusCode) {
        return this.$emit('editLoading', false);
      }

      item.TriggerList.forEach(n => {
        rs.Result?.TriggerList?.forEach(info => {
          if (n.ExtraKeyId === info.ExtraKeyId && n.MsgId === info.MsgID && n.KeyId === info.KeyID) {
            const matchData = info.OperationType.find(type => type.Value === n.OperationType)
            if (!matchData) return;
            
            const m = {...info, OperationValue: n.OperationType, OperationName: matchData.Name};

            if (m.ValueType === 'UIControl_Slider' && m.OperationValue === 4) {
              m.ValueType = 'UIControl_ChooseRange';
            }

            if (m.ValueType === 'UIControl_ChooseRange' || (m.ValueType === 'UIControl_Slider' && m.OperationValue === 8 )) {
              m.DefaultValue = [Number(n.Value1), Number(n.Value2)];
            } else {
              m.DefaultValue = Number(n.Value1);
            }
            
            this.deviceOption.push({
              VDeviceId: item.VDeviceId, DeviceName: item.DeviceName, AreaName: item.AreaName,
              locationindex: item.locationindex, ChannelId: item.ChildId, ClassSku: item.ClassSku,
              ChildId: item.ChildId, IsDel: item.IsDel, IsInOtherArea: item.IsInOtherArea,
              triggle: m
            })
          }
        })
      })
      
      this.$emit('editLoading', false)
    },

    /**
     *  找出设备已经选中的能力的相应下标
     *  @param triggleaction 能力列表
     *  @param trigger 已选中的能力
     *  @param copy 是否替换能力
     */
    findDeviceAbilityIndex (triggleaction, trigger,copy=false) {
      let index = -1
      triggleaction.forEach((n, i) => {
        if (n.OperationName === trigger.OperationName &&  n.ExtraKeyId === trigger.ExtraKeyId){
          if(copy){
              //替换能力,区分DefaultValue是否数组
            if(n.hasOwnProperty('DefaultValue') && trigger.hasOwnProperty('DefaultValue') && n.DefaultValue !=null && trigger.DefaultValue !=null){
            //DefaultValue都有数组
            if( Array.isArray(n.DefaultValue)  && Array.isArray(trigger.DefaultValue)){
              n.DefaultValue= trigger.DefaultValue
            }
            //DefaultValue一个是数组
            if( Array.isArray(n.DefaultValue) && n.DefaultValue.length>1  && !Array.isArray(trigger.DefaultValue)){
              n.DefaultValue[1]= trigger.DefaultValue
            }
             //DefaultValue都不是数组
            if(!Array.isArray(n.DefaultValue)  &&  !Array.isArray(trigger.DefaultValue)){
              n.DefaultValue= trigger.DefaultValue
            }
            }
           }
           index = i
          }
        }
      )
      return index
    },

    trigglePannel(list, param) {
      this.triggleaction = []
      if (!list.length) return

      list.forEach(n => {
        if (n.ValueType === 'UIControl_ChooseRange' || (n.ValueType === 'UIControl_Slider' && n.OperationValue === 8)) {
          n.DefaultValue = [n.Min, n.Max]
        } else if (n.ValueType === 'UIControl_MultipleDropdownList') {
          n.DefaultValue = n.DefaultValue.split(',')
        } else {
          n.DefaultValue = Number(n.DefaultValue)
        }
        
        n.OperationType.forEach(m => {
          const _param = deepCloneNew({
            ...n, 
            OperationName: m.Name, 
            OperationValue: m.Value, 
            ischeck: false
          })
          
          if (m.Value === 4) {
            Object.assign(_param, {
              ValueType: 'UIControl_ChooseRange', 
              DefaultValue: [n.Min, n.Max]
            })
          }
          
          if (m.Value === 8) {
            Object.assign(_param, {
              ValueType: 'UIControl_Slider', 
              DefaultValue: [n.Min, n.Max]
            })
          }
          
          this.triggleaction.push(_param)
        })
      })

      const handleEdit = (copy = false) => {
        if (
          param?.vDeviceId === this.modifyItem?.VDeviceId && 
            this.triggleaction.length && 
            this.modifyItem.triggle
          ) {
            const i = this.findDeviceAbilityIndex(this.triggleaction, this.modifyItem.triggle, copy)
            if (!copy && i >= 0) {
              this.checkRadio(this.triggleaction[i], i)
            }
          }
      }
      
      handleEdit(true)
      
      this.triggleaction.sort((m, n) => {
        if (m.KeyID !== n.KeyID) {
          return m.KeyID - n.KeyID
        }
        if (m.ExtraKeyId !== n.ExtraKeyId) {
          return m.ExtraKeyId - n.ExtraKeyId
        }
        if (!Array.isArray(m.DefaultValue) && !Array.isArray(n.DefaultValue)) {
          return n.DefaultValue - m.DefaultValue
        }
        return 1
      })

      handleEdit(false)
    },

    drowisdisabled () {
      if (this.iftttmodel == null) {
        if (this.deviceOption.length === 0 && this.timeOption.length === 0 && this.triggermanual.length === 0) {
          this.triggerTypeList.forEach(n => {
            n.disabled = false
          })
        }
      }
    },

    modifyItemClear () {
      this.modifyItem = null
      this.canMultipleSelect = true
    },

    handleAdd2(command) {
      const actions = {
        a: () => {
          if (this.sunOption) {
            warning(this, this.$t('iftttset.timeOrSunExclusive'))
            return
          }
          this.value1 = this.value2 = this.value3 = ''
          this.timeOption.length === 0 
            ? (this.timingset = true) 
            : warning(this, this.$t('iftttset.setTiming'))
        },
        d: () => {
          if (this.timeOption.length > 0) {
            warning(this, this.$t('iftttset.timeOrSunExclusive'))
          } else if (this.sunOption) {
            warning(this, this.$t('iftttset.setSun'))
          } else {
            this.dialogSun = true
          }
        },
        b: () => {
          if (this.triggermanual.length === 0) {
            if (this.isVisual) {
              this.$emit('openDiveceList', 'trigger', this.deviceOption)
              return
            }
            this.multipleDialogGroup = true
            this.dialogGroup = true
          } else {
            warning(this, this.$t('iftttset.delhandlewarning'))
          }
        }
      }
      
      if (actions[command]) {
        actions[command]()
      } else {
        
        this.iftttmodel && !this.iftttmodel.IsManual
          ? warning(this, this.$t('iftttset.candohandlewarning'))
          : this.validateCanTrigger()
      }
      
      this.setDisabled(command)
    },

    validateCanTrigger () {
      // 验证handle
      if (this.timeOption.length > 0 || this.deviceOption.length > 0) {
        warning(this, this.$t('iftttset.deldevicewarning'))
      } else if (this.triggermanual.length > 0) {
        warning(this, this.$t('iftttset.onehandlewarning'))
      } else {
        this.triggermanual.push({ TriggerType: 2, TRI_NAME: '' })
      }
    },

    okTrigger () {
      // 确定选择triggle
      if (this.temtriggle == null) {
        warning(this, this.$t('iftttset.SelecTtriggle'))
        return
      }

      if (this.modifyItem != null && this.multipleTemtriggle.length == 1) {
        this.modifyItem["triggle"] = this.multipleTemtriggle[0]
      } else {
        let pushDevices = [];
        this.multipleTemtriggle.forEach(triggle => {
            let devices = this.addDevicesTemp.map(
            device => ({
              VDeviceId: device.VDeviceId,
              DeviceName: device.DeviceName,
              AreaName: device.AreaName,
              ClassSku: device.ClassSku,
              ChannelId: device.ChannelId,
              ChannelName: device.ChannelName,
              ChildId: device.ChildId,
              triggle: {
                ...triggle
              },
            })
          );
          pushDevices = pushDevices.concat(devices);
        })
        this.deviceOption = this.deviceOption.concat(pushDevices);
      }
      this.formatelistTrigger()

      this.temtriggle = null;
      this.addDevicesTemp = [];
      this.triggleaction = [];
      this.temdevice = {}
      this.multipleTemtriggle = []
      this.multipleCur= []

      this.triggle = false
      this.setDisabled('g')
    },

    cancel () {
      this.triggle = false
      this.actionPannel = false
      //重置多选
      this.multipleCur = []
      this.multipleTemtriggle = []
    },

    setDisabled (type) {
      if (type === 'c') {
        this.triggerTypeList.forEach(n => {
          n.disabled = true
        })
      }
      
      if (type === 'g') {
        this.triggerTypeList.forEach(n => {
          if (n.value === 'c') {
            n.disabled = true
          }
        })
      }
    },


    modifyCanMultipleSelect(item) {
      this.modifyItem = item;

      this.canMultipleSelect = false;
      this.confirmTrigger([item]);
    },

    confirmTrigger (devices) {
      debugger
      this.addDevicesTemp = devices;
      // triggle选择好设备以后处理
      postWebIOSocket('sync_info_removeall_event')
      this.temdevice = devices[0]
      this.doFindTriggerAbility()
    },

    // 阻止滑动或者其他能力配置事件,往上
    stopCheckRadio (item, index) {
      if (this.canMultipleSelect) {
        if (this.multipleCur.indexOf(index) === -1) {
          this.multipleCur.push(index)
          this.multipleTemtriggle.push(item)
        }
      } else {
        this.multipleCur= [index]
        this.multipleTemtriggle = [item]
      }

      item.ischeck = true
      this.temtriggle = item
    },  
    doFindTriggerAbility () {
      let para = { vDeviceId: this.temdevice.VDeviceId }
      //假如是inno旋钮按键设置自动化,不能取所有的trigger
      if(this.isInnoTrigger){
        this.cur = 1
        this.trigglePannel([this.deviceOption[0]?.triggle], para)
        this.triggle = true
      }
      FindTriggerAbility(para, this.functionDoFindTriggerAbility)
      this.dialogGroup = false
    },
     functionDoFindTriggerAbility (rs, param) {
      debugger
      if (rs.Result.TriggerList) {
        this.cur = -1
        this.trigglePannel(rs.Result.TriggerList, param);
        this.triggle = true
      }
    },
    timeSettingOk (time) {
      this.value1 = time
      this.triggleTimeAdd();
      this.modifyItemClear();
    },
   
  }
}


export default triggerMixins;